import { render } from "./BatteryPanel.vue?vue&type=template&id=631b5a4d"
import script from "./BatteryPanel.vue?vue&type=script&lang=js"
export * from "./BatteryPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__